import axios from 'axios'
import { API_URL } from './Cnx'

const REQUEST_URL = 'api/tipos_traslado'

export const getTiposTraslado = q =>
  axios.get(`${API_URL}/${REQUEST_URL}/`, { params: q })
